import { i18n } from 'LibNeo'
import { all, call } from 'typed-redux-saga'
import { errorHandler, showError } from 'Modules'

const generateErrors = (errors) => {
	if (!errors) return null
	if (typeof errors !== 'object') return errors
	if (Array.isArray(errors)) {
		return errors.map(generateErrors)
	}
	return Object.keys(errors).map((key): any => {
		const values = errors[key].join('. ')
		if (errors[key].includes('non_unique')) {
			return `${i18n(`errors.agent.${key}`)}: ${i18n('errors.username.non_unique')}`
		}
		return `${i18n(`errors.agent.${key}`)}: ${values}`
	})
}
export function* showCustomErrors(error: any, isUpdate: boolean) {
	const { errors } = error.data
	if (Array.isArray(errors)) {
		if (isUpdate) {
			const combinedErrors = errors.reduce((acc, response) => {
				const { error } = response
				return { ...acc, ...error }
			}, {})
			yield* all(generateErrors(combinedErrors).map((item) => call(showError, item)))
		} else {
			yield* call(errorHandler, error)
		}
	} else {
		yield* all(generateErrors(errors).map((item) => call(showError, item)))
	}
}
